export function emailAction(catalog, definition, settings) {
    const policy = catalog.policies.find(p => p.key === definition.key);
    const active = catalog.versions.find(v => v.id === policy?.activeVersionId && v.definitionKey === definition.key);
    const drafts = catalog.drafts.filter(d => d.definitionKey === definition.key);
    const activeDraft = drafts.find(d => d.id === active?.draftId);
    const published = catalog.versions.filter(v => v.definitionKey === definition.key && v.state === 'Published');
    const pause = catalog.policies.find(p => p.key === '__pause');
    const restrictions = [];
    if (!settings)
        restrictions.push('Verzendconfiguratie onbekend');
    else {
        if (!settings.enabled)
            restrictions.push('Mailverzending niet ingeschakeld');
        if (!settings.productionRecipientsAllowed)
            restrictions.push('Alleen toegestane testontvangers');
    }
    if (!pause)
        restrictions.push('Algemene pauzestatus onbekend');
    else if (pause.enabled)
        restrictions.push('Alle Resend-mails gepauzeerd');
    if (!active || active.state !== 'Published')
        restrictions.push('Geen geldige gepubliceerde versie gekoppeld');
    if (definition.key === 'hours.submitted-admin') {
        const config = settings?.hoursNotifications;
        if (!config)
            restrictions.push('Interne urenconfiguratie nog niet bekend');
        else {
            if (!config.enabled)
                restrictions.push('Interne urenmeldingen nog niet vrijgegeven');
            if (!config.recipientsConfigured)
                restrictions.push('Interne ontvangers nog niet ingericht');
            if (config.scheduleRequired !== false && !config.scheduleConfigured)
                restrictions.push('Verzendplanning nog niet ingericht');
        }
    }
    return {
        policy, active, activeDraft, drafts, published, restrictions,
        directSubmission: definition.key === 'hours.submitted-admin' && settings?.hoursNotifications?.trigger === 'submission' && settings.hoursNotifications.scheduleRequired === false,
        editorDraft: policy?.activeVersionId ? activeDraft : drafts[0],
        protected: definition.critical || !!activeDraft?.protected,
        status: !policy ? 'Regel ontbreekt' : !policy.enabled ? 'Uit' : restrictions.length ? 'Aan · beperkt' : 'Aan',
    };
}
export function matchesEmailAction(definition, catalog, query, addresses = []) {
    const drafts = catalog.drafts.filter(d => d.definitionKey === definition.key);
    return [definition.name, definition.trigger, definition.recipient, ...addresses, ...drafts.map(d => d.name)]
        .join(' ').toLocaleLowerCase().includes(query.trim().toLocaleLowerCase());
}
